export default {
    methods: {
        lowerCase(string) {
            const words = string.split(' ')
            return words.map((word) => word[0].toLowerCase() + word.substring(1)).join(' ')
        },
        singularize(string) {
            return string.replace(/s$/, '')
        },
        pluralize(string) {
            return `${string}s`
        },
        capitalize(string) {
            if (!string) return ''
            return string.charAt(0).toUpperCase() + string.slice(1)
        },
    },
}
